<template>
  <transition name="fade">
    <div v-show="show" :class="{ 'loading--first': isFirst }" class="loading">
      <div v-show="isFirst" class="loading-content--first">
        <img
          src="//static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/loading.gif"
        />
      </div>
      <div v-show="!isFirst" class="loading-content">
        <img
          class="loading-content__img"
          src="//static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/loading.gif"
        />
        <p class="loading-content__text">加载中...</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Loading",
  data() {
    return {
      show: false,
      isFirst: true,
      timer: null,
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler: function (val) {
        if (!val) {
          if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
          }
          this.timer = setTimeout(() => {
            this.show = false;
            this.isFirst = false;
          }, 400);
        } else {
          this.show = true;
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
.loading {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
  &--first {
    background: #fff;
  }
  &-content {
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    padding: 15px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);

    &--first {
      width: 49px;
      height: 50px;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    &__img {
      display: block;
      width: 49px;
      height: 50px;
      margin: 0 auto;
    }

    &__text {
      margin-top: 8px;
      font-size: 12px;
      color: #212831;
      text-align: center;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
